module.exports = __webpack_public_path__ + "static/img/img6.50324a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img6.jpg
// module id = rmKQ
// module chunks = 1